// extracted by mini-css-extract-plugin
export default {"introImage":"benefits_introImage__cu31w"};